import { createContext, useContext, useEffect, useState, useRef } from 'react'
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider,
  signInWithRedirect,
  getAuth,
} from 'firebase/auth'
import { getFirebaseAuth } from '../firebase'
import PropTypes from 'prop-types'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'

export const UserContext = createContext()

export function AuthContextProvider({ children }) {
  const [currentUser, setCurrentUser] = useState()
  const [auth, setAuth] = useState(null)

  // Defer Firebase Auth init so getProjectConfig doesn't block initial render
  useEffect(() => {
    const id = setTimeout(() => setAuth(getFirebaseAuth()), 0)
    return () => clearTimeout(id)
  }, [])

  useEffect(() => {
    if (!auth) return
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user)
    })
    return unsubscribe
  }, [auth])

  function signIn(email, password) {
    const a = auth || getFirebaseAuth()
    return signInWithEmailAndPassword(a, email, password)
  }
  function signUp(email, password) {
    const a = auth || getFirebaseAuth()
    return createUserWithEmailAndPassword(a, email, password)
  }
  function logOut() {
    logoutHandler()
  }
  function googleSignIn() {
    const a = auth || getFirebaseAuth()
    const googleAuthProvider = new GoogleAuthProvider()
    return signInWithRedirect(a, googleAuthProvider)
  }

  return (
    <UserContext.Provider value={{ currentUser, signIn, logOut, googleSignIn }}>
      {children}
    </UserContext.Provider>
  )
}

export function UserAuth() {
  return useContext(UserContext)
}

AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
